/**
 * useNotificationStore
 */
import { useCallback } from 'react';

import {
    Queries,
    ApolloLib,
    Mutations,
} from 'bdvp-graphql';

const {
    useMutation,
    useQuery,
} = ApolloLib;

const { GET_NOTIFICATION } = Queries;

const { DISMISS_NOTIFICATION } = Mutations;

export const updateLocalNotification = (data) => {

    const id = data?.notification?.id;

    if(!__CLIENT__ || !id) {

        return;

    }

    try {

        localStorage.setItem(id, JSON.stringify({
            timestamp: Date.now(),
            data,
        }));

    } catch (e) {

        if (
            [
                'QuotaExceededError',
                'NS_ERROR_DOM_QUOTA_REACHED',
            ].includes(e.name)
        ) {

            // handle quota limit exceeded error
            // possibly message to user

        }

        console.log(e);

    }

};

const useNotificationStore = (id) => {

    const { data } = useQuery(GET_NOTIFICATION, {
        variables: {
            id,
        },
        skip: !id,
    });

    const [dismissNotification] = useMutation(DISMISS_NOTIFICATION);

    const _dismissNotification = useCallback((id) => {

        updateLocalNotification({
            notification: {
                id,
                isDismissed: true,
            },
        });
        dismissNotification({
            variables: {
                id,
            },
        });

    }, [dismissNotification]);

    return {
        shouldShowNotification: data?.notification?.isDismissed === false,
        dismissNotification: id && __CLIENT__ ? _dismissNotification : () => {},
    };

};

export default useNotificationStore;
